import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { ArrowLeft, Save } from 'lucide-react';
import { PromotionForm } from './components/PromotionForm';
import { PromotionFormData, Promotion } from './types';
import { usePromotions } from './hooks/usePromotions';

export const EditPromotionPage: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { promotions, updatePromotion } = usePromotions();
  const [loading, setLoading] = useState(false);
  const [promotion, setPromotion] = useState<Promotion | null>(null);

  useEffect(() => {
    if (id && promotions.length > 0) {
      const foundPromotion = promotions.find(p => p.id === parseInt(id));
      if (foundPromotion) {
        setPromotion(foundPromotion);
      } else {
        navigate('/promotions');
      }
    }
  }, [id, promotions, navigate]);

  const handleSubmit = async (data: PromotionFormData) => {
    if (!promotion) return;

    try {
      setLoading(true);
      await updatePromotion(promotion.id, data);
      navigate('/promotions', {
        replace: true,
        state: { message: 'Promoción actualizada exitosamente' }
      });
    } catch (error) {
      console.error('Error updating promotion:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/promotions');
  };

  if (!promotion) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-lg">Cargando promoción...</div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Button
            variant="ghost"
            size="sm"
            onClick={handleCancel}
            className="text-gray-600 hover:text-gray-900"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Volver
          </Button>
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Editar Promoción</h1>
            <p className="text-gray-600 mt-1">Modifica la información de la promoción "{promotion.name}"</p>
          </div>
        </div>
      </div>

      {/* Form Card */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Save className="w-5 h-5" />
            Información de la Promoción
          </CardTitle>
        </CardHeader>
        <CardContent>
          <PromotionForm
            promotion={promotion}
            onSubmit={handleSubmit}
            onCancel={handleCancel}
            loading={loading}
          />
        </CardContent>
      </Card>
    </div>
  );
};